/** @format */
import React, { FunctionComponent } from 'react';

import { GridRepeater } from '@toucan/client/shared/components/grid-repeater';

import { SearchFilterSkeleton } from './components/search-filter/skeleton';
import { StyledSearchFilterGroup } from './index';
import { SearchFilterGroupSkeletonProps } from './types';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'search-filter-group-skeleton';

export const SearchFilterGroupSkeleton: FunctionComponent<
    SearchFilterGroupSkeletonProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    numFilters,
    ...otherProps
}) => (
    <StyledSearchFilterGroup data-testid={dataTestId} {...otherProps}>
        <GridRepeater
            gridColumns={5}
            gridGap="0.8rem"
            data-testid={`${dataTestId}__grid-repeater`}
        >
            {Array(numFilters)
                .fill(null)
                .map((_, index) => (
                    <SearchFilterSkeleton
                        // eslint-disable-next-line react/no-array-index-key -- Legacy code: do not use as an example.
                        key={index}
                        data-testid={`${dataTestId}__search-filter`}
                    />
                ))}
        </GridRepeater>
    </StyledSearchFilterGroup>
);
